import { render, staticRenderFns } from "./BAEventDetailPage.vue?vue&type=template&id=2f706a16&"
import script from "./BAEventDetailPage.vue?vue&type=script&lang=ts&"
export * from "./BAEventDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports